import React from "react";
import Select from "react-select";
import { X } from "lucide-react";

const DivisionModal = ({
  showModal,
  setShowModal,
  resetForm,
  divisionForm,
  setDivisionForm,
  selectedDepartment,
  setSelectedDepartment,
  departmentOptions,
  formError,
  handleSubmit,
  isUpdating,
  isEditing,
  title,
}) => {
  if (!showModal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/50 backdrop-blur-sm"
        onClick={() => {
          setShowModal(false);
          resetForm();
        }}
      />

      {/* Modal */}
      <div className="relative bg-white rounded-xl shadow-xl w-full max-w-md mx-4">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
          <button
            onClick={() => {
              setShowModal(false);
              resetForm();
            }}
            className="p-1 rounded-md hover:bg-gray-100 transition-colors"
          >
            <X size={20} className="text-gray-500" />
          </button>
        </div>

        {/* Form */}
        <div className="p-6 space-y-4">
          {formError && (
            <div className="text-red-600 text-sm bg-red-50 p-3 rounded-md">
              {formError}
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Division Name
            </label>
            <input
              type="text"
              placeholder="Enter division name"
              value={divisionForm.name}
              onChange={(e) =>
                setDivisionForm({ ...divisionForm, name: e.target.value })
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Department
            </label>
            <Select
              value={selectedDepartment}
              classNamePrefix="custom-select"
              options={departmentOptions}
              placeholder="Select Department"
              isClearable
              isSearchable={false}
              onChange={setSelectedDepartment}
              className="w-full"
              required
            />
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 p-6 border-t border-gray-200">
          <button
            onClick={() => {
              setShowModal(false);
              resetForm();
            }}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={isUpdating}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            {isUpdating
              ? isEditing
                ? "Updating..."
                : "Adding..."
              : isEditing
              ? "Update"
              : "Add"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DivisionModal;
